/* eslint-disable max-lines-per-function */
import { useDtfStore } from "../store";
import { cn } from "tailwind-variants";
import "./Styles.scss";
import { renderList } from "common/vue/render-list";

export default function Styles({ ...restProps }) {
  const styles = [
    {
      label: "Straight",
      value: "straight"
    },
    {
      label: "Vertical",
      value: "vertical"
    }
  ];
  const store = useDtfStore();

  function letterNumberArtwork() {
    return store.letterNumberArtwork;
  }

  function handleSelect(option) {
    const style = option.value;
    store.updateArtworkValues({
      index: 0,
      style
    });
    store.updateAllLetterPreviews();
  }

  return (
    <div {...restProps} className={cn("styles", restProps.className)}>
      {renderList(styles, style => (
        <div
          className={cn(
            "styles__item",
            style.value === letterNumberArtwork().style && "styles__item--selected"
          )}
          key={style.value}
          onClick={() => {
            handleSelect(style);
          }}
          data-testid="styles-div"
        >
          <div className={cn("styles__text-preview", `styles__text-preview--${style.value}`)}>
            <img
              className={cn("styles__image", `styles__image--${style.value}`)}
              src={`https://jiffy.imgix.net/gen/letters-pdp/${style.value}.png`}
              alt={style.label}
            />
          </div>
          <div className="styles__label">{style.label}</div>
        </div>
      ))}
    </div>
  );
}
